import { DateTime } from 'luxon'

import { getStatus } from '@/shared/config/missions'
import type { MissionWithProgress } from '@/types/mission'

import type { MissionUiStatus } from '../constants/status'

export const getMissionUiStatus = (
  mission: MissionWithProgress
): MissionUiStatus => {
  const submissionStatus = mission._progress?.status

  /* A entrega é fato, não janela: missão concluída segue concluída depois do
     prazo — sem isso, "encerrada" apagava progresso, XP e a etiqueta. */
  if (submissionStatus === 'approved' || mission._progress?.finished) {
    return 'success'
  }

  const timeStatus = getStatus({
    start_at: mission.start_at,
    end_at: mission.end_at
  })

  if (timeStatus?.slug === 'soon') return 'locked'

  /* Recusa tem status próprio: agrupada com `progress`, a lista dizia "Em
     andamento" para uma evidência que o produtor já recusou. Encerrada, não há
     como reenviar — o prazo vence. */
  if (
    submissionStatus === 'refused' ||
    submissionStatus === 'awaiting_correction'
  ) {
    if (timeStatus?.slug === 'closed') return 'expired'
    return submissionStatus === 'refused' ? 'danger' : 'progress'
  }

  /* A revisão do produtor acontece depois do encerramento: pendência dele não
     apaga a evidência enviada. */
  if (submissionStatus === 'pending' || mission._progress?.submitted) {
    return 'progress'
  }

  if (timeStatus?.slug === 'closed') return 'expired'

  return 'available'
}

/* Missão que ainda pede ação do participante: iniciar, continuar ou reenviar
   a evidência recusada. Fonte única para filtros, recomendadas e home. */
export const isMissionActionable = (uiStatus: string): boolean =>
  uiStatus === 'available' || uiStatus === 'progress' || uiStatus === 'danger'

export const isMissionEndingSoon = (
  mission: MissionWithProgress,
  withinHours = 24
): boolean => {
  if (!mission.end_at) return false

  const timeStatus = getStatus({
    start_at: mission.start_at,
    end_at: mission.end_at
  })

  if (timeStatus?.slug !== 'open') return false

  const endAt = DateTime.fromISO(mission.end_at)
  const now = DateTime.local()

  return endAt > now && endAt.diff(now, 'hours').hours <= withinHours
}

export const getMissionRewardScore = (mission: MissionWithProgress): number =>
  (mission.coin_reward ?? 0) * 2 + (mission.point_reward ?? 0)
